/*
 * @Author: your name
 * @Date: 2020-06-05 11:06:15
 * @LastEditTime: 2020-06-10 16:45:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \esign-landing\src\views\common\components\mixins\qiyu.js
 */

// 获取url上的参数
function getQueryStrings(url) {
  // eslint-disable-next-line
  const _url = url || window.location.search
  const theRequest = {}
  if (_url.indexOf('?') !== -1) {
    const str = _url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }

  return theRequest
}

// 七鱼客服
export default {
  methods: {
    addQiyuScript() {
      /* eslint-disable */
      ; (function (w, d, n, a, j) {
        w[n] =
          w[n] ||
          function () {
            ; (w[n].a = w[n].a || []).push(arguments)
          }
        j = d.createElement('script')
        j.async = true
        j.src = 'https://qiyukf.com/script/e7172fc844d88cd3ae196678ea38da5e.js?hidden=1'
        d.body.appendChild(j)

        j.onload = function () {
          window.ysf('config', {
            uid: '', // 用户ID
            groupid: '397595188', // 客服组ID
            data: JSON.stringify([
              { key: 'real_name', value: '' }, // 姓名
              { key: 'mobile_phone', value: '' }, // 手机号
              { key: 'email', value: '' }, // 邮箱
              { key: 'address', value: '' }, // 地址
              { type: 'crm_param', key: '', value: '' }, // 自定义字段(sourceType): USER - 注册用户; PURCHASER - 管理员录入
            ]),
          })
        }
      })(window, document, 'ysf')
      /* eslint-enable */
    },

    /**
     *打开客服弹窗
     */
    handleCustomerServiceClick(options) {
      const newCustomerServiceLink = options && options.newCustomerServiceLink
      const entry = options && options.entry
      const title = `${window.document.title}-${entry || 'other'}`

      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        // eslint-disable-next-line camelcase
        window.meteor && window.meteor.track && window.meteor.track('consult_effective', { convert_id: '1655145710006284' })
      }
      this.$tsignData.track('click_customer_service', {
        $url: window.location.href,
        weizhi: entry,
      })
      this.$tsignData.track('sign_landingpage_onlineservice')

      // // 登出客服系统
      // window.ysf('logoff')

      // window.ysf('open', {
      //   uid: '', // 用户ID
      //   groupid: '397595188', // 客服组ID
      //   data: JSON.stringify([
      //     { key: 'real_name', value: '' }, // 姓名
      //     { key: 'mobile_phone', value: '' }, // 手机号
      //     { key: 'email', value: '' }, // 邮箱
      //     { key: 'address', value: '' }, // 地址
      //     { type: 'crm_param', key: '', value: '' }, // 自定义字段(sourceType): USER - 注册用户; PURCHASER - 管理员录入
      //   ]),
      // })

      window.ysf('config', {
        title, // 自定义访客咨询来源页的标题
        referrer: window.location.href, // 自定义访客咨询来源页的url
        t: title,
        groupid: '483648412',
        success() {
          if (/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent)) {
            // 移动端
            window.location.href = window.ysf('url')
          } else {
            // pc端
            // window.ysf('open')
            const serviceLinkObj = {
              separatEentrance:
                'https://hztg.qiyukf.com/client?k=e7172fc844d88cd3ae196678ea38da5e&wp=1&robotShuntSwitch=0&sid=3881399&language=zh-cn',
              sealmanage:
                'https://p.qiao.baidu.com/cps/chat?siteId=18635174&userId=43265381&siteToken=071de2cef6ae08e8c0f605780799fd7a&cp=&cr=&cw=%E7%BD%91%E9%A1%B5%E5%8F%B3%E4%BE%A7',
            }

            if (newCustomerServiceLink === 'separatEentrance' || newCustomerServiceLink === 'sealmanage') {
              serviceLinkObj[newCustomerServiceLink] &&
                window.open(serviceLinkObj[newCustomerServiceLink], 'kefuWindow', 'height=631,width=842,top=50')

              return
            }

            // 七鱼客服链接上拼接位置参数
            const [origin, search] = window.ysf('url').split('?')
            const obj = Object.assign(getQueryStrings(`?${search}`), { t: window.encodeURI(title) })
            const arr = Object.keys(obj).map(k => {
              return `${k}=${obj[k]}`
            })
            // eslint-disable-next-line
            kefuWindow = window.open(`${origin}?${arr.join('&')}`, 'kefuWindow', 'height=631,width=842,top=50')
          }
        },
      })
    },

    /**
     * 换了一个模板类型：百度推广客服
     * 客服模板与https://guangzhou.esign.cn/sempc一致
     */
    handleCustomerServiceBaiduClick(obj = {}) {
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        // eslint-disable-next-line camelcase
        window.meteor && window.meteor.track && window.meteor.track('consult_effective', { convert_id: '1655145710006284' })
      }
      this.$tsignData.track('click_customer_service')
      this.$tsignData.track('sign_landingpage_onlineservice')

      window.ysf('config', {
        groupid: '483648412',
        success() {
          if (/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent)) {
            // 移动端
            window.location.href = window.ysf('url', {
              ...obj,
            })
          } else {
            // pc端
            window.ysf('open', {
              ...obj,
            })
          }
        },
      })
    },

    /**
     * 0406新增两个落地页(saas和api)，引用信息客服地址，后面可能都用这个链接
     */
    handleCustomerClick(obj = {}) {
      window.ysf('config', {
        groupid: '483648412',
        success() {
          if (/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent)) {
            // 移动端
            window.location.href = window.ysf('url', {
              ...obj,
            })
          } else {
            // pc端
            window.ysf('open', {
              ...obj,
            })
          }
        },
      })
    },

    /**
     * ABTest页面https://testlanding.tsign.cn/landing/semsal
     */
    handleSemSalClick(obj = {}) {
      window.ysf('config', {
        groupid: '483982239',
        success() {
          if (/(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent)) {
            // 移动端
            window.location.href = window.ysf('url', {
              ...obj,
            })
          } else {
            // pc端
            window.ysf('open', {
              ...obj,
            })
          }
        },
      })
    },

    /**
     * 20240613 开始替换百度爱番番的在线咨询客服
     */
    handleNewBaiduService() {
      this.$tsignData.track('click_customer_service')
      this.$tsignData.track('sign_landingpage_onlineservice')
      const url =
        'https://ada.baidu.com/site/wjzq4si7/agent?imid=93f93a5d065df292082d8b2c1471a571&ch=90&sch=0&wid=4b534c47-78f5-4e1c-33b0-172412350423_0_0&queryPathKey=%2Fbot#merchant_bot_layer&utm_source=sem**baidu**in百度付费'
      window.open(url, 'kefuWindow', `height=660,width=1200,top=-150,left=${this.$store.state.user.left}`)
    },
  },
}
